var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"self-publishing-flow-quote-footer-la-boutique-sobook"}},[_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12"},[_c('SelfPublishingFlowQuoteFooterDefault')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }